import {useTranslation} from "react-i18next";

export default function ProjectSupportPanel(props) {
    const {t, i18n} = useTranslation();
    const projectSupportUrl = window.win_project_support_redirect;
    return (
        <div className="callout form__callout">
            <div className="callout__content">
                <h6>
                    {t('Directory.ProjectSupportPanel1')}
                </h6>
                <p>
                    {t('Directory.ProjectSupportPanel2')}
                </p>
            </div>

            <div className="callout__actions">
                <a href={projectSupportUrl} className="btn btn--outline">
                    {t('Directory.ProjectSupportPanel3')}
                </a>
            </div>
        </div>
    )
}
